import React, { useState, useEffect, useRef } from "react";
import useStyles from "./styles";
import { allowedAttachmentsImages, maskAccountNumber, saveActivlityLogInfo } from '../../../src/components/Common/Extensions';
import { withSnackbar } from "./../../components/Message/Alert";
import { GetUserInfo } from "../../Services/GetUserInfo";
import { PostDataAPI } from '../../Services/APIService';
import Loader from './../../components/Loader/Loader';
import UserPlaceholder from "./../../assets/img/action/userPlaceholder.svg";
import BannerBg from "./../../assets/img/default-background-image.png";
import EditPen from './../../assets/img/action/penWhite.svg';
import infoIcon from '../../assets/img/icons/question-circle-Bold.svg';
import newLine from '../../assets/img/icons/newLine.png';
import portIn from '../../assets/img/icons/port-in.png';
import updateSim from '../../assets/img/icons/dual-sim.png';
import simCard from '../../assets/img/icons/sim-card.png';
import noSim from '../../assets/img/icons/no-sim.png';
import password from '../../assets/img/icons/password.png';
import bill from '../../assets/img/icons/bill.png';
import ShoppingBag from '../../assets/img/icons/shopping-bag.png';
import billing from '../../assets/img/icons/bill2.png';
import file from '../../assets/img/icons/file.png';
import phoneBook from '../../assets/img/icons/phone-book.png';
import Notifications from '../../assets/img/icons/Notifications.png';
import NoRecord from "../../components/NoRecord/NoRecord";
import AddNewLine from "../lineManagement/components/addLineToAccount/AddNewLine";
import ChangePhoneNumberDialog from "../lineManagement/components/changePhoneNumber/ChangePhoneNumber";
import ChangeVMPassword from "../lineManagement/components/changeVMPassword/ChangeVMPassword";
import PortANumber from "../lineManagement/components/newRegistrationDialog/NewRegistrationDialog";
//import PortANumber from "./components/portANumber/PortANumber";
import OrderNewSIMS from "./components/orderNewSIM/OrderNewSIM";
import BulkSwapping from "./components/swapBulk/SwapBulk";
import ImeiSwap from "./components/ImeiSwap/ImeiSwap";
import SwapSim from "../lineManagement/components/swapsim/SwapSim";
import RechargeDialog from "../dashboard/components/recharge/RechargeDialog";
import dotsIcon from '../../assets/img/icons/dots.svg';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { GetUserRolesRights } from '../../Services/GetUserRolesRights';
import {
    Button,
    Card, Collapse, Grid, Paper, Typography, FormControlLabel, Checkbox
} from "@material-ui/core";
import SuspendPhoneNumber from "../lineManagement/components/suspendNumber/SuspendPhoneNumber";
import ChangeShippingAddress from '../prepaid/components/changeShippingAddress/ChangeShippingAddress';//'./components/changeShippingAddress/ChangeShippingAddress';

function CorporateDashboard({ ...props }) {
    const classes = useStyles();
    let user_info = JSON.parse(GetUserInfo());
    let user_role_rights_list = JSON.parse(GetUserRolesRights());
    const [loginUser, setLoginUser] = useState(user_info.user);
    const commonAttachments = allowedAttachmentsImages();
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);
    const [userName] = useState(user_info.user.userName);
    const [isPrepaid] = useState(user_info.user.isPrepaid);
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [customerOffers, setCustomerOffers] = useState([]);
    const [changePhoneNumberDialogState, setChangePhoneNumberDialogState] = useState(false);
    const [showAddLineToExistingAccountDialog, setShowAddLineToExistingAccount] = useState(false);
    const [showSuspendPhoneNumberDialog, setShowSuspendPhoneNumberDialog] = useState(false);
    const [showChangeVMPassworDialog, setShowChangeVMPassworDialog] = useState(false);
    const [showOrderNewSIMSDialog, setShowOrderNewSIMSDialog] = useState(false);
    const [showBulkSwappingDialog, setShowBulkSwappingDialog] = useState(false);
    const [imeiSwapDialog, setImeiSwapDialog] = useState(false);
    const [showPortANumber, setShowPortANumber] = useState(false);
    const [rechargeDialog, setRechargeDialog] = useState(false);
    const [userSwapSim, setUserSwapSim] = useState(false);
    const [changeShippingAddress, setChangeShippingAddress] = useState(false);
    const [objAddress, setObjAddress] = useState({});

    const logDashboardActivity = (area, activity, details, activityStatus = "Success") => {
        saveActivlityLogInfo(
            area,
            activity,
            `${details}. Account: ${maskAccountNumber(accountNumber)}`,
            accountNumber,
            customerID,
            activityStatus
        );
    }

    const logDialogOpenSuccess = (area, dashboardTitle, dialogTitle, details = "") => {
        logDashboardActivity(
            area,
            `${dashboardTitle} Dialog Opened`,
            `Dialog title: ${dialogTitle}. ${details || `User opened ${dialogTitle} dialog from ${dashboardTitle} tile on corporate dashboard`}`
        );
    };

    const logDialogOpenFailed = (area, dashboardTitle, dialogTitle, reason) => {
        logDashboardActivity(
            area,
            `${dashboardTitle} Dialog Open Failed`,
            `Dialog title: ${dialogTitle}. User attempted to open ${dialogTitle} dialog from ${dashboardTitle} tile on corporate dashboard, but ${reason}`,
            "Failed"
        );
    };

    const openDashboardDialog = (area, dashboardTitle, dialogTitle, setDialogOpen, details = "") => {
        try {
            setDialogOpen(true);
            logDialogOpenSuccess(area, dashboardTitle, dialogTitle, details);
        }
        catch (error) {
            const reason = error?.message || "the dialog could not be opened";
            logDialogOpenFailed(area, dashboardTitle, dialogTitle, reason);
            showMessage("Error", reason, "error", 3000);
        }
    };

    const AddLineToExistingAccount = () => {
        if (customerInformation?.isPrepaid && !customerInformation?.creditCardNumber) {
            logDialogOpenFailed("Line Management", "Add New Line", "Add New Line", "payment information was missing");
            showMessage("Alert", "Please provide valid payment information to add a line", "warning", 5000);
            openDashboardDialog(
                "Payment Management",
                "Payment Information",
                "Payment Information",
                setChangeShippingAddress,
                "User opened Payment Information dialog from Add New Line tile because payment information was missing"
            );

        }
        else {
            openDashboardDialog("Line Management", "Add New Line", "Add New Line", setShowAddLineToExistingAccount);
        }
    }
    const openImeiSwap = () => {
        openDashboardDialog("Line Management", "IMEI Bulk Swaping", "IMEI Swapping", setImeiSwapDialog);
    }
    const openBulkSwappingDialog = () => {
        openDashboardDialog("Line Management", "Bulk Swapping", "Bulk Swapping", setShowBulkSwappingDialog);
    }
    const openPortInDialog = () => {
        openDashboardDialog("Line Management", "Port In", "Port a Number", setShowPortANumber);
    }
    const openLostPhoneUpdateSimDialog = () => {
        openDashboardDialog("Line Management", "Lost Phone Update SIM", "Swap SIM", setUserSwapSim);
    }
    const openChangePhoneNumberDialog = () => {
        openDashboardDialog("Line Management", "Change Phone Number", "Change Phone Number", setChangePhoneNumberDialogState);
    }
    const openSuspendLineDialog = () => {
        openDashboardDialog("Line Management", "Suspend / Deactivate Line", "Suspend/Deactivate Phone Number", setShowSuspendPhoneNumberDialog);
    }
    const openVoicemailPasswordDialog = () => {
        openDashboardDialog("Line Management", "Change Voicemail Password", "Change Voicemail Password", setShowChangeVMPassworDialog);
    }
    const openRechargeDialog = () => {
        openDashboardDialog("Payment Management", "Pay Bill", "Express Payment", setRechargeDialog);
    }
    const openOrderMoreSimDialog = () => {
        openDashboardDialog("Order SIM", "Order More SIM", "Order More SIM", setShowOrderNewSIMSDialog);
    }
    const logLineManagementNavigation = () => {
        logDashboardActivity("Line Management", "Line Management Dashboard Tile Opened", "User opened Line Management page from Line Management tile on corporate dashboard");
    }
    const logAddressBookNavigation = () => {
        logDashboardActivity("Notify Contacts", "Address Book Dashboard Tile Opened", "User opened Address Book page from Address Book tile on corporate dashboard");
    }
    const logPrintBillNavigation = () => {
        logDashboardActivity("Payment History", "Print Bill Dashboard Tile Opened", "User opened Payment History page from Print Bill tile on corporate dashboard");
    }
    const handleSuccessClose = (_message) => {
        showMessage("Success", _message, "success", 3000);
        setShowAddLineToExistingAccount(false);
        setChangePhoneNumberDialogState(false);
        setUserSwapSim(false);
        setShowSuspendPhoneNumberDialog(false);
        setRechargeDialog(false);
        setShowPortANumber(false);
        setShowChangeVMPassworDialog(false);
        setShowOrderNewSIMSDialog(false);
        setShowBulkSwappingDialog(false);
        setChangeShippingAddress(false);

    }
    const handleChangeAddressSuccessClose = (_address) => {
        var existingData = customerInformation;


        existingData.billingAddress1 = _address.address1
        existingData.billingAddress2 = _address.address2
        existingData.billingCity = _address.city;
        existingData.billingState = _address.state;
        existingData.billingZip = _address.zip;
        existingData.billingName = _address.billingName;
        existingData.creditCardNumber = _address.creditCardNumber;
        existingData.creditCardType = _address.creditCardType;
        existingData.creditCardExpiration = _address.creditCardExpiration;
        existingData.creditCardExpirationCvv = _address.creditCardExpirationCvv;

        showMessage("Success", "Payment information updated successfully.", "success", 3000);
        setChangeShippingAddress(false);
        setTimeout(() => {
            setShowAddLineToExistingAccount(true);
        }, 1000);
    }


    const getCustomerOffers = () => {
        var obj = { AccountNumber: accountNumber };
        PostDataAPI("fwoffer/loadCustomerOffers", obj, true).then((result) => {
            if (result.success && result.data != null) {
                setCustomerOffers(result.data);
            } else {
                setCustomerOffers([]);
            }
        })
    }
    const redirectTo = (offer) => {
        const link = typeof offer === "string" ? offer : offer?.redirectTo;
        const title = typeof offer === "string" ? "offer" : offer?.title || "offer";
        logDashboardActivity("Offers", "Offer Opened", `User opened offer ${title} from corporate dashboard`);
        window.open(link, '_blank');
    }

    const [bedgeImage, setBedgeImage] = useState({ file: null, fileToSend: null, fileName: "" });
    const inputFile = useRef(null);
    const uploadFile = () => {

        logDashboardActivity("Account Summary", "Profile Image Upload Clicked", "User clicked corporate profile image edit icon from corporate dashboard");
        inputFile.current.click();
    };

    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setBedgeImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })

        updateImage(e.target.files[0], true);
    }

    const [coverImage, setCoverImage] = useState({ file: null, fileToSend: null, fileName: "" });
    const inputCover = useRef(null);
    const uploadCover = () => {

        logDashboardActivity("Account Summary", "Banner Image Upload Clicked", "User clicked corporate banner image edit icon from corporate dashboard");
        inputCover.current.click();
    };

    function uploadCoverFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setCoverImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })
        updateImage(e.target.files[0], false);

    }

    function updateImage(file, isUpdateProfile) {
        const formData = new FormData();
        formData.append("accountNumber", accountNumber);
        if (isUpdateProfile) {
            formData.append("corporateProfile", file);
        } else {
            formData.append("corporateBanner", file);
        }

        formData.append("IsUpdateProfile", isUpdateProfile);
        setIsLoading(true);
        PostDataAPI("customer/updateCorporateProfile", formData, true, "formData").then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                if (isUpdateProfile) {
                    user_info.user.corporateProfilePath = result.data.corporateProfilePath;
                } else {
                    user_info.user.corporateBannerPath = result.data.corporateBannerPath;
                }

                sessionStorage.removeItem('user_info')
                sessionStorage.setItem('user_info', JSON.stringify(user_info))
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        })
    }
    const [customerInformation, setCustomerInformation] = useState();
    const getCustomerInformation = () => {

        var obj = { AccountNumber: accountNumber.trim() };
        setIsLoading(true);
        PostDataAPI("telispire/getCustomerInformationLocalDb", obj, true).then((result) => {
            if (result.success && result.data != null) {
                setCustomerInformation(result.data);
                setObjAddress({
                    address1: result.data.billingAddress1,
                    address2: result.data.billingAddress2,
                    city: result.data.billingCity,
                    state: result.data.billingState,
                    zip: result.data.billingZip,
                    billingName: result.data.billingName,
                    creditCardNumber: result.data.creditCardNumber,
                    creditCardType: result.data.creditCardType,
                    creditCardExpiration: result.data.creditCardExpiration,
                    creditCardExpirationCvv: result.data.creditCardExpirationCvv,
                });
            }
            else {
                setIsLoading(false);
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);

        })
    }

    const updatedBillingInfoDashboard = (_updateBillingInfo) => {
        //var existingCustomerInfo = customerInformation.objCustomerInfo;
        //existingCustomerInfo.billingAddress1 = _updateBillingInfo.address1
        //existingCustomerInfo.billingAddress2 = _updateBillingInfo.address2
        //existingCustomerInfo.billingCity = _updateBillingInfo.city;
        //existingCustomerInfo.billingState = _updateBillingInfo.state;
        //existingCustomerInfo.billingZip = _updateBillingInfo.zip;
        //existingCustomerInfo.billingName = _updateBillingInfo.billingName;
        //existingCustomerInfo.creditCardNumber = _updateBillingInfo.creditCardNumber;
        //existingCustomerInfo.creditCardExpiration = _updateBillingInfo.creditCardExpiration;
        //existingCustomerInfo.creditCardType = _updateBillingInfo.creditCardType;
        //existingCustomerInfo.creditCardExpirationCvv = _updateBillingInfo.creditCardExpirationCvv;
        //setCustomerInformation(prevState => ({
        //    ...prevState,
        //    objCustomerInfo: existingCustomerInfo
        //}));

    }

    useEffect(() => {
        debugger
        if (accountNumber > 0) {
            getCustomerInformation();
            getCustomerOffers();
        }

    }, [])
    return (
        <>

            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            {window.isIpadView ? '' :
                <div className={classes.header}>
                    <Typography component="h2">Welcome {customerInformation?.fullName}</Typography>

                    <div className={classes.floatRight}>
                        <h4 className={classes.accountType}>Account Type: {isPrepaid ? 'Prepaid' : 'Postpaid'} </h4>
                    </div>
                </div>}

            <Grid className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xl={9} lg={9} md={window.isIpadView ? 12 : 9} sm={12} xs={12}  >

                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                            <div className={classes.PRofileTop}>
                                <div className={classes.CoverImg}>
                                    <div className={classes.CoverSec}>

                                        <div className={classes.coverImg}>
                                            {coverImage.file || loginUser.corporateBannerPath ?
                                                <>
                                                    <img alt="" src={coverImage.file ? coverImage.file : '.' + loginUser.corporateBannerPath} />
                                                </>
                                                : <img alt="" src={BannerBg}></img>
                                            }
                                            <img alt="" className={classes.CoverEditICon} src={EditPen} onClick={uploadCover} />
                                            <form>
                                                <div>
                                                    <input type="file" id="fileUploadField" ref={inputCover} className={classes.inputFile} onChange={uploadCoverFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                                {window.isIpadView ?
                                    <div className={classes.whiteBox}>
                                        <div className={classes.profileImg}>
                                            {bedgeImage.file || loginUser.corporateProfilePath ?
                                                <>
                                                    <img alt="" src={bedgeImage.file ? bedgeImage.file : '.' + loginUser.corporateProfilePath} />
                                                </>

                                                : <img alt="" src={UserPlaceholder} style={{ objectFit: 'contain' }} />

                                            }
                                            <img alt="" className={classes.EditICon} src={EditPen} onClick={uploadFile} />
                                            <form>
                                                <div>
                                                    <input type="file" id="fileUploadField" ref={inputFile} className={classes.inputFile} onChange={uploadSingleFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                                </div>
                                            </form>
                                        </div>
                                        <div className={classes.AccountName}>
                                            <Typography className={classes.accountCardMember} variant="h5">{customerInformation?.fullName}</Typography>
                                        </div>

                                    </div> : ''}
                            </div>
                            {window.isIpadView ?
                                <>
                                    <Grid container spacing={2}>
                                        {/* <Grid item md={4} xs={4} sm={4}>
                                            {
                                                user_role_rights_list.some(item => item.rightName === 'sendAndViewNotification' && item.permissionCode > 0) ?

                                                    <div className={classes.ResQuickLinks}>
                                                        <img alt=""  src={Notifications}></img>
                                                        <Typography variant="h6" className={classes.accountHomeTitle} style={{ color: '#76CABB' }}>Notification</Typography>
                                                    </div>

                                                    : ''}
                                        </Grid> */}
                                        <Grid item md={4} xs={4} sm={4}>
                                            {
                                                user_role_rights_list.some(item => item.rightName === 'address-book' && item.permissionCode > 0) ?
                                                    <Link to={"/app/address-book"} onClick={logAddressBookNavigation}>
                                                        <div className={classes.ResQuickLinks}>
                                                            <img alt="" src={phoneBook}></img>
                                                            <Typography variant="h6" className={classes.accountHomeTitle} style={{ color: '#6889C7' }}>Address Book</Typography>
                                                        </div>
                                                    </Link>
                                                    : ''}
                                        </Grid>
                                        <Grid item md={4} xs={4} sm={4}>
                                            {
                                                user_role_rights_list.some(item => item.rightName === 'orderMoreSIM' && item.permissionCode > 0) ?
                                                    <div className={classes.ResQuickLinks} onClick={openOrderMoreSimDialog}>
                                                        <img alt="" src={ShoppingBag}></img>
                                                        <Typography variant="h6" className={classes.accountHomeTitle} style={{ color: '#774A9B' }}>Order SIMs</Typography>
                                                    </div>
                                                    : ''}
                                        </Grid>


                                    </Grid>
                                    <hr style={{ opacity: '0.4' }} />
                                </>
                                : ''
                            }
                        </Grid>

                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                            <Typography className={classes.sectionHeading}>SIM  Management</Typography>
                            <Grid container spacing={2}>
                                {
                                    user_role_rights_list.some(item => item.rightName === 'addNewLine' && item.permissionCode > 0) ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={AddLineToExistingAccount}>
                                            <div className={`${classes.QuickLinksNew} ${classes.addNewLine}`} >
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Add New Line">*/}
                                                {/*        <img alt=""  src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img alt="" src={newLine}></img>
                                                    <Typography className={classes.accountHomeTitle}>Add New Line</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''
                                }

                                {
                                    user_role_rights_list.some(item => item.rightName === 'portANumber' && item.permissionCode > 0) ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={openPortInDialog}>
                                            <div className={`${classes.QuickLinksNew} ${classes.portIn}`} >
                                                <div className={classes.QuickLinkscontain}>
                                                    <img alt="" src={portIn}></img>
                                                    <Typography className={classes.accountHomeTitle}>Port In</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''
                                }



                                {user_role_rights_list.some(item => item.rightName === 'simSwipe' && item.permissionCode > 0) ?
                                    <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={openLostPhoneUpdateSimDialog}>
                                        <div className={`${classes.QuickLinksNew} ${classes.updateSim}`} >
                                            {/*<span className={classes.changeLink}>*/}
                                            {/*    <Tooltip title="Lost Phone Update SIM">*/}
                                            {/*    </Tooltip>*/}
                                            {/*</span>*/}
                                            <div className={classes.QuickLinkscontain}>
                                                <img src={updateSim}></img>
                                                <Typography className={classes.accountHomeTitle}>Lost Phone Update SIM</Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                    : ''
                                }

                                {
                                    user_role_rights_list.some(item => item.rightName === 'changePhoneNumber' && item.permissionCode > 0) ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={openChangePhoneNumberDialog}>
                                            <div className={`${classes.QuickLinksNew} ${classes.simCard}`} >
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Update Number on Existing Line">*/}
                                                {/*        <img src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={simCard} alt=""></img>
                                                    <Typography className={classes.accountHomeTitle}>Change Phone Number</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        : ''
                                }
                            </Grid>
                        </Grid>



                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                            <Typography className={classes.sectionHeading}>Line  Management</Typography>
                            <Grid container spacing={2}>
                                {user_role_rights_list.some(item => item.rightName === 'lineManagement' && item.permissionCode > 0) ?
                                    <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                                        <Link to={"/app/lineManagement"} onClick={logLineManagementNavigation}>
                                            <div className={`${classes.QuickLinksNew} ${classes.file}`}>
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Line Management">*/}
                                                {/*        <img src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={file}></img>
                                                    <Typography className={classes.accountHomeTitle}>Line Management</Typography>
                                                </div>
                                            </div>
                                        </Link>
                                    </Grid>
                                    : ''
                                }

                                {
                                    user_role_rights_list.some(item => item.rightName === 'suspendNumber' && item.permissionCode > 0) ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={openSuspendLineDialog}>
                                            <div className={`${classes.QuickLinksNew} ${classes.noSim}`}>
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Suspend / Deactivate Line">*/}
                                                {/*        <img src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={noSim}></img>
                                                    <Typography className={classes.accountHomeTitle}>Suspend / Deactivate Line</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''
                                }
                                {
                                    user_role_rights_list.some(item => item.rightName === 'voiceMailPassword' && item.permissionCode > 0) ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={openVoicemailPasswordDialog}>
                                            <div className={`${classes.QuickLinksNew} ${classes.password}`} >
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Change Voice mail Password">*/}
                                                {/*        <img src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={password}></img>
                                                    <Typography className={classes.accountHomeTitle}>Change Voicemail Password</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''
                                }
                            </Grid>
                        </Grid>

                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                            <Typography className={classes.sectionHeading}>Payment Management</Typography>
                            <Grid container spacing={2}>
                                {
                                    user_role_rights_list.some(item => item.rightName === 'expressPayment' && item.permissionCode > 0) && isPrepaid ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6} onClick={openRechargeDialog}>
                                            <div className={`${classes.QuickLinksNew} ${classes.bill}`}>
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Pay Bill">*/}
                                                {/*        <img src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={bill}></img>
                                                    <Typography className={classes.accountHomeTitle}>Pay Bill</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''

                                }
                                {
                                    user_role_rights_list.some(item => item.rightName === 'payment-history' && item.permissionCode > 0) ?
                                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                                            <Link to={"/app/payment-history"} onClick={logPrintBillNavigation}>
                                                <div className={`${classes.QuickLinksNew} ${classes.billing}`}>
                                                    {/*<span className={classes.changeLink}>*/}
                                                    {/*    <Tooltip title="Print Bill">*/}
                                                    {/*        <img src={infoIcon} />*/}
                                                    {/*    </Tooltip>*/}
                                                    {/*</span>*/}
                                                    <div className={classes.QuickLinkscontain}>
                                                        <img src={billing}></img>
                                                        <Typography className={classes.accountHomeTitle}>Print Bill</Typography>
                                                    </div>
                                                </div>
                                            </Link>

                                        </Grid>
                                        :
                                        ''
                                }


                            </Grid>
                        </Grid>


                    </Grid>
                    {window.isIpadView ? '' :
                        <Grid item xl={3} md={3} xs={3} sm={3} lg={3} className={classes.profileGrid}>
                            <Grid container spacing={2}>
                                <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                                    <div className={classes.prrfileMain}>
                                        {/* <div className={classes.iconMian}>
                                            <img src={dotsIcon} />
                                        </div> */}


                                        <div className={classes.profileContain}>
                                            <div className={classes.corporateProfile}>
                                                {bedgeImage.file || loginUser.corporateProfilePath ?
                                                    <>
                                                        <img src={bedgeImage.file ? bedgeImage.file : '.' + loginUser.corporateProfilePath} />
                                                    </>

                                                    : <img src={UserPlaceholder} style={{ objectFit: 'contain' }} />

                                                }
                                                <img className={classes.EditIConMain} src={EditPen} onClick={uploadFile} />
                                                <form>
                                                    <div>
                                                        <input type="file" id="fileUploadField" ref={inputFile} className={classes.inputFile} onChange={uploadSingleFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                                    </div>
                                                </form>

                                            </div>
                                            <h5>{customerInformation?.fullName}</h5>
                                            {/*<p>Cooper Admin</p>*/}

                                        </div>
                                        <hr style={{ opacity: '0.4' }} />
                                        <div className={classes.accountDetails}>
                                            <div className={classes.accountSection}>
                                                <Typography variant="h4">Account #: <b> {maskAccountNumber(accountNumber)}</b></Typography>

                                            </div>
                                            <div className={classes.accountSection}>
                                                <Typography variant="h4">Billing Cycle: <b> {customerInformation?.billingCycle ? customerInformation?.billingCycle + 'th of each month' : ''}</b></Typography>
                                            </div>
                                            {/*<div className={classes.accountSection}>*/}
                                            {/*    <Typography variant="h4">Last Login Date:</Typography>*/}
                                            {/*    <Typography variant="h4">{customerInformation?.lstWireless?.length}</Typography>*/}
                                            {/*</div>*/}

                                        </div>



                                    </div>
                                </Grid>

                                {/*{*/}
                                {/*    user_role_rights_list.some(item => item.rightName === 'sendAndViewNotification' && item.permissionCode > 0) ?*/}
                                {/*        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>*/}
                                {/*            <div className={`${classes.QuickLinksRight} ${classes.notifications}`}>*/}
                                {/*                */}{/*<span className={classes.changeLink}>*/}
                                {/*                */}{/*    <Tooltip title="Send / View Notification">*/}
                                {/*                */}{/*        <img src={infoIcon} />*/}
                                {/*                */}{/*    </Tooltip>*/}
                                {/*                */}{/*</span>*/}
                                {/*                <div className={classes.QuickLinkscontain}>*/}
                                {/*                    <img src={Notifications}></img>*/}
                                {/*                    <Typography className={classes.accountHomeTitle}>Send / View Notification</Typography>*/}
                                {/*                </div>*/}
                                {/*            </div>*/}
                                {/*        </Grid>*/}
                                {/*        :*/}
                                {/*        ''*/}

                                {/*}*/}

                                {
                                    user_role_rights_list.some(item => item.rightName === 'address-book' && item.permissionCode > 0) ?
                                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>
                                            <Link to={"/app/address-book"} onClick={logAddressBookNavigation}>
                                                <div className={`${classes.QuickLinksRight} ${classes.phoneBook}`} >
                                                    {/*<span className={classes.changeLink}>*/}
                                                    {/*    <Tooltip title="Address Book">*/}
                                                    {/*        <img src={infoIcon} />*/}
                                                    {/*    </Tooltip>*/}
                                                    {/*</span>*/}
                                                    <div className={classes.QuickLinkscontain}>
                                                        <img src={phoneBook}></img>
                                                        <Typography className={classes.accountHomeTitle}>Address Book</Typography>
                                                    </div>
                                                </div>
                                            </Link>
                                        </Grid> : ''
                                }

                                {
                                    user_role_rights_list.some(item => item.rightName === 'orderMoreSIM' && item.permissionCode > 0) ?
                                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12} onClick={openOrderMoreSimDialog}>
                                            <div className={`${classes.QuickLinksRight} ${classes.ShoppingBag}`} >
                                                {/*<span className={classes.changeLink}>*/}
                                                {/*    <Tooltip title="Order More SIM">*/}
                                                {/*        <img src={infoIcon} />*/}
                                                {/*    </Tooltip>*/}
                                                {/*</span>*/}
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={ShoppingBag}></img>
                                                    <Typography className={classes.accountHomeTitle}>Order More SIM</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''

                                }

                                {/* {
                                    user_role_rights_list.some(item => item.rightName === 'orderMoreSIM' && item.permissionCode > 0) ?
                                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12} onClick={() => setShowBulkSwappingDialog(true)}>
                                            <div className={`${classes.QuickLinksRight} ${classes.ShoppingBag}`} >
                                          
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={ShoppingBag}></img>
                                                    <Typography className={classes.accountHomeTitle}>Bulk Swapping</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''

                                }

                                  {
                                    user_role_rights_list.some(item => item.rightName === 'orderMoreSIM' && item.permissionCode > 0) ?
                                        <Grid item xl={12} md={12} xs={12} sm={12} lg={12} onClick={() => openImeiSwap()}>
                                            <div className={`${classes.QuickLinksRight} ${classes.ShoppingBag}`} >
                                              
                                                <div className={classes.QuickLinkscontain}>
                                                    <img src={ShoppingBag}></img>
                                                    <Typography className={classes.accountHomeTitle}>IMEI Bulk Swaping</Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                        :
                                        ''

                                } */}

                                

                            </Grid>
                        </Grid>}




                    <Grid item xl={12} md={12} xs={12} sm={12} lg={12}>

                        {customerOffers.length > 0 ?

                            <div className={classes.figgersContainer}>
                                <Typography className={classes.OffersTop}>Special<span> 15%</span> Discount on Products for Corporate Customers</Typography>

                                <Grid container spacing={2}>
                                    {
                                        customerOffers.map((cardItem, index) => {
                                            console.log("." + cardItem?.photoPath);
                                            if (cardItem.offerType == 'text_image') {
                                                return <Card className={classes.figgersEligibleCard} onClick={() => redirectTo(cardItem)}>
                                                    <Grid item xl={4} lg={4} md={4} sm={6} xs={12} >
                                                        <Typography className='figgersCardTitle'>{cardItem.title}</Typography>
                                                        <Typography className='figgersCardDesc'>{cardItem.description}</Typography>
                                                    </Grid>
                                                    {(cardItem.photoPath && cardItem.photoPath != '') ? <img src={"." + cardItem?.photoPath} alt="figgers eligible" /> : ''}
                                                </Card>
                                            } else if (cardItem.offerType == 'text') {
                                                return <Card className={classes.figgersEligibleCard} onClick={() => redirectTo(cardItem)}>
                                                    <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                                                        <Typography className='figgersCardTitle'>{cardItem.title}</Typography>
                                                        <Typography className='figgersCardDesc'>{cardItem.description}</Typography>
                                                    </Grid>
                                                </Card>
                                            } else if (cardItem.offerType == 'image') {
                                                return <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                                                    {(cardItem.photoPath && cardItem.photoPath != '') ? <a href={cardItem.redirectTo} target="_blank" onClick={(event) => { event.preventDefault(); redirectTo(cardItem); }}><img className={classes.figgersEligibleCard} src={"." + cardItem?.photoPath} alt={cardItem.title} /></a> : ''}
                                                </Grid>
                                            } else {
                                                return '';
                                            }

                                        })
                                    }
                                </Grid>
                            </div>
                            :
                            <>

                                <div className={classes.offersContainer}>
                                    <Typography className="paperTitle">Offers</Typography>
                                    <NoRecord Icon={true} message="No Offer found"></NoRecord>
                                </div>
                            </>
                        }

                    </Grid>

                </Grid>
            </Grid>
            {
                showAddLineToExistingAccountDialog ?
                    <AddNewLine
                        dialogOpenClose={showAddLineToExistingAccountDialog}
                        handleClose={() => { setShowAddLineToExistingAccount(false) }}
                        handleSuccessClose={handleSuccessClose}
                        customerNumber={accountNumber}
                        customerName={customerInformation?.fullName}
                        accountNumber={accountNumber}
                        loginUserName={loginUser.firstName}
                        isPrepaid={isPrepaid}
                    ></AddNewLine>
                    : null
            }
            {
                changePhoneNumberDialogState ? <ChangePhoneNumberDialog
                    dialogOpenClose={changePhoneNumberDialogState}
                    handleClose={() => setChangePhoneNumberDialogState(false)}
                    handleSuccessClose={handleSuccessClose}
                    accountNumber={accountNumber}
                    userName={customerInformation?.fullName}
                    emailAddress={customerInformation?.email}
                    loginUserName={loginUser.firstName}
                    fromDashboard={true}
                /> : null
            }

            {
                userSwapSim ? <SwapSim
                    dialogOpenClose={userSwapSim}
                    handleClose={() => setUserSwapSim(false)}
                    handleSuccessClose={handleSuccessClose}
                    loginUserName={loginUser.firstName}
                    accountNumber={accountNumber}
                    userName={customerInformation?.fullName}
                    emailAddress={customerInformation?.email}
                    fromDashboard={true}
                /> : null
            }
            {
                showSuspendPhoneNumberDialog ? <SuspendPhoneNumber
                    dialogOpenClose={showSuspendPhoneNumberDialog}
                    handleClose={() => setShowSuspendPhoneNumberDialog(false)}
                    handleSuccessClose={handleSuccessClose}
                    loginUserName={loginUser.firstName}
                    accountNumber={accountNumber}
                    userName={customerInformation?.fullName}
                    emailAddress={customerInformation?.email}
                    fromDashboard={true}
                /> : null
            }

            {rechargeDialog ?
                <RechargeDialog dialogOpenClose={rechargeDialog}
                    handleSuccessClose={handleSuccessClose}
                    handleClose={() => { setRechargeDialog(false) }}
                    userDate={customerInformation}
                /> : ''
            }

            {showPortANumber ?
                <PortANumber
                    dialogOpenClose={showPortANumber}
                    handleSuccessClose={handleSuccessClose}
                    handleClose={() => { setShowPortANumber(false) }}
                    userDate={customerInformation}
                    updatedBillingInfoDashboard={updatedBillingInfoDashboard}
                    isPrepaid={isPrepaid}
                    fromDashboard={true}
                /> : ''
            }
            {
                showChangeVMPassworDialog ?
                    <ChangeVMPassword
                        dialogOpenClose={showChangeVMPassworDialog}
                        handleSuccessClose={handleSuccessClose}
                        handleClose={() => { setShowChangeVMPassworDialog(false) }}
                        accountNumber={accountNumber}
                        userName={customerInformation?.fullName}
                        emailAddress={customerInformation?.email}
                        loginUserName={loginUser.firstName}
                        fromDashboard={true}
                    >
                    </ChangeVMPassword> : ''
            }
            {
                showOrderNewSIMSDialog ?
                    <OrderNewSIMS
                        dialogOpenClose={showOrderNewSIMSDialog}
                        handleSuccessClose={handleSuccessClose}
                        handleClose={() => { setShowOrderNewSIMSDialog(false) }}
                        accountNumber={accountNumber}
                        userName={customerInformation?.fullName}
                        emailAddress={customerInformation?.email}
                        loginUserName={loginUser.firstName}
                        fromDashboard={true}
                    >
                    </OrderNewSIMS> : ''
            }
            {
                showBulkSwappingDialog ?
                    <BulkSwapping
                        dialogOpenClose={showBulkSwappingDialog}
                        handleSuccessClose={handleSuccessClose}
                        handleClose={() => { setShowBulkSwappingDialog(false) }}
                        accountNumber={accountNumber}

                        customerNumber={accountNumber}
                        customerName={customerInformation?.objCustomerInfo?.fullName}



                    >
                    </BulkSwapping> : ''
            }

            {
                imeiSwapDialog ?
                    <ImeiSwap
                        dialogOpenClose={imeiSwapDialog}
                        handleSuccessClose={handleSuccessClose}
                        handleClose={() => { setImeiSwapDialog(false) }}
                        accountNumber={accountNumber}

                        customerNumber={accountNumber}
                        customerName={customerInformation?.objCustomerInfo?.fullName}



                    >
                    </ImeiSwap> : ''
            }



            {
                changeShippingAddress ?
                    <ChangeShippingAddress
                        dialogOpenClose={changeShippingAddress}
                        handleClose={() => { setChangeShippingAddress(false) }}
                        handleSuccessClose={handleChangeAddressSuccessClose}
                        addressType={"updateBillingAddress"}
                        accountNumber={accountNumber}
                        objAddress={objAddress}
                    ></ChangeShippingAddress>
                    : null
            }
        </>
    )


}
export default withSnackbar(CorporateDashboard);
